import {
	radii,
	fonts,
	fontSizes,
	opacity,
	fontWeights,
	space,
	breakpoints,
	sizes,
	borderWidths,
} from "./theme";

// global tokens
const colors: any = {
	cag1: "#E73567",
	cag2: "#A81C6E",
	cag3: "#B1005A",
	cag4: "#A9005B",
	cag5: "#3D509E",
	cag6: "#583B8D",
	cag7: "#682E82",
	cag8: "#152251",
	cag9: "#15102B",
	cag10: "#FFFFFF",
	cag11: "#F6F6F6",
	cag12: "#000000",
	cag13: "#374D62",
	cag14: "#e1e4e7",
};

const shadows: any = [
	"0 10px 10px 0 rgba(219, 219, 219, 0.5)",
	"0 2px 9px 0 rgba(231, 53, 103, 0.5)",
	"0 3px 25px 0 rgba(218, 218, 218, 0.37)",
	"0px 3px 25px rgba(103, 103, 103, 0.37)",
	"0 0 9px 0 rgba(227, 6, 19, 0.5)",
	"0px 3px 25px rgba(103, 103, 103, 0.37)",
];

shadows.default = shadows[2];
shadows.hover = shadows[5];
shadows.accent = shadows[1];
shadows.error = shadows[4];
shadows.warning = "0 0 9px 0 rgba(238, 149, 4, 0.5)";

colors["text-color"] = colors["cag12"];
colors["lighter-text-color"] = colors["cag13"];
colors["text-color-over-background"] = colors["cag10"];
colors["text-color-hover"] = colors["cag1"];
colors["informative-text-color"] = colors["cag8"];
colors["positive-text-color"] = "#609833";
colors["negative-text-color"] = "#e30613";
colors["warning-text-color"] = "#ee9504";

// PRIMARY CTA
// backgrounds
colors["cta-primary-background-color-default"] = colors["cag1"];
colors["cta-primary-background-color-hover"] = colors["cag4"];
colors["cta-primary-background-color-focus"] = colors["cag4"];
// text
colors["cta-primary-text-color-default"] = colors["cag10"];
colors["cta-primary-text-color-hover"] = colors["cag10"];
colors["cta-primary-text-color-focus"] = colors["cag10"];

// SECONDARY CTA
// text
colors["cta-secondary-text-color-default"] = colors["cag1"];
colors["cta-secondary-text-color-hover"] = colors["cag4"];
colors["cta-secondary-text-color-focus"] = colors["cag4"];
// borders
colors["cta-secondary-border-color-default"] = colors["cag1"];
colors["cta-secondary-border-color-hover"] = colors["cag4"];
colors["cta-secondary-border-color-focus"] = colors["cag4"];

// TERTIARY CTA
// text
colors["cta-tertiary-text-color-default"] = colors["cag1"];
colors["cta-tertiary-text-color-hover"] = colors["cag4"];
colors["cta-tertiary-text-color-focus"] = colors["cag4"];

// BUTTON CTA
// text
colors["cta-button-text-color-default"] = colors["cag12"];
colors["cta-button-text-color-hover"] = colors["text-color-hover"];
colors["cta-button-text-color-focus"] = colors["text-color-over-background"];

// border
colors["cta-button-border-color-hover"] = colors["cag1"];

// background
colors["cta-button-background-color-active"] = colors["cag1"];

// Checkbox
colors["checkbox-fill-color"] = colors["cag1"];
colors["checkbox-bg-color"] = colors["cag10"];
colors["checkbox-font-color"] = colors["cag13"];

// Radio
colors["radio-fill-color"] = colors["cag1"];

colors["background-default-color"] = colors["cag10"];
colors["background-dark-color"] = colors["cag9"];
colors["informative-background-color"] = "#e9f5fe";

colors["informative-border-color"] = "#a1c2da";

colors["outline-color"] = colors["cag1"];

colors["divider-color"] = "#e8e8e8";

colors["progress-bar-fill-color"] = colors["cag1"];

colors["stepper-active-color"] = colors["cag1"];
colors["stepper-inactive-color"] = "#d8dce0";

//Badges
colors["neutral-background-color"] = colors["cag8"];
colors["positive-background-color"] = "#609833";
colors["negative-background-color"] = "#e30613";
colors["warning-background-color"] = "#ee9504";

//CHIP
colors["chip-read-only-border-color"] = colors["cag12"];

//COUNT
colors["count-active-background-color"] = "rgba(231, 53, 103, 0.1)"; // cag1 with 0.1 opacity

//FAQAccordion
colors["accordion-default-header-color"] = colors["cag12"];

// Circular Loader
colors["circular-loader-background"] = "#bebfbe";
colors["circular-loader-accent-color"] = colors["cag1"];

// Backdrop
colors["primary-backdrop"] = colors["cag8"];

//LabelNumber
colors["label-number-background-color"] = colors["cag8"];

//Table
colors["table-head-bg-color"] = colors["cag11"];
colors["table-body-font-color"] = colors["cag13"];
colors["table-head-font-color"] = colors["cag12"];
colors["table-border-color"] = colors["cag14"];
colors["table-bg-color"] = colors["cag10"];
colors["table-row-highlight-color"] = colors["cag1"];

//Banner
colors["banner-informative-color"] = colors["cag1"];

//Toggle
colors["toggle-bg-color"] = colors["cag14"];
colors["toggle-default-bg-color"] = colors["cag10"];
colors["toggle-default-color"] = colors["cag13"];
colors["toggle-info-bg-color"] = colors["cag1"];
colors["toggle-info-color"] = colors["cag10"];
colors["toggle-inactive-option-color"] = colors["cag13"];

export const CAGTheme = {
	colors,
	radii,
	fonts,
	fontSizes,
	opacity,
	lineHeights: [1.4],
	letterSpacings: [0.7],
	fontWeights,
	space,
	shadows,
	sizes,
	breakpoints,
	borders: {
		normalBorder: "1px solid #f1f1f1",
		errorBorder: `1px solid red`,
		primaryBorder: `1px solid ${colors["cag1"]}`,
		warningBorder: `1px solid #ee9504`,
	},
	borderWidths,
	name: "CAG",
};
